import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

export default class Header extends React.Component {
  state = {
    active: false
  }

  toggleNav = () => {
    this.setState({ active: !this.state.active });
  }

  render() {
    const path = this.props.location.pathname;

    return <div className="hero-head">
        <nav role="navigation" className="navbar is-transparent">
          <div className="navbar-brand">
            <Link to="/" className="navbar-item">
              <img src="/assets/images/engaged_logo.png" alt="Logo" />
            </Link>
            <span className="navbar-burger burger" data-target="navbarMenuHeroA" onClick={this.toggleNav}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </div>
          <div id="navbarMenuHeroA" className={classNames('navbar-menu', {
            'is-active': this.state.active
          })}>
            <div className="navbar-end">
              <Link to="/" className={classNames('navbar-item', {
                'is-active': path === '/'
              })}>
                Home
              </Link>
              <Link to="/request" className="navbar-item">
                Get Access Code
              </Link>
              <div className="navbar-item has-dropdown is-hoverable">
                <Link to="/more/benefit" className="navbar-link">
                  Learn More
                </Link>
                <div className="navbar-dropdown is-boxed">
                  <Link to="/more/benefit" className="navbar-item">
                    Benefits of Measure-based Guidance
                  </Link>
                  <Link to="/more/sequential" className="navbar-item">
                    Sequential Care Model
                  </Link>
                  <Link to="/more/problem" className="navbar-item">
                    Problem I Want Treated
                  </Link>
                  <Link to="/more/objective" className="navbar-item">
                    Agree on Treatment Objective
                  </Link>
                  <Link to="/more/options" className="navbar-item">
                    What Options Should I Consider?
                  </Link>
                  <Link to="/more/menu" className="navbar-item">
                    Offer Menu of Resonable Choices
                  </Link>
                  <Link to="/more/using" className="navbar-item">
                    Using the Menu of Reasonable Choice
                  </Link>
                  <Link to="/more/preference" className="navbar-item">
                    My Preference
                  </Link>
                  <Link to="/more/intervention" className="navbar-item">
                    Intervention
                  </Link>
                  <Link to="/more/assessing" className="navbar-item">
                    Assessing Outcome
                  </Link>
                  <Link to="/more/predictive" className="navbar-item">
                    Predictive Value of 2 Week Outcome
                  </Link>
                  <Link to="/more/understanding" className="navbar-item">
                    Understanding Your Report
                  </Link>
                  <Link to="/more/strategies" className="navbar-item">
                    Basic Self Directed Strategies
                  </Link>
                  <Link to="/more/other" className="navbar-item">
                    Other Resources
                  </Link>
                </div>
              </div>
              <Link to="/about" className={classNames('navbar-item', {
                'is-active': path === '/about'
              })}>
                About Us
              </Link>
              <Link to="/contact" className={classNames('navbar-item', {
                'is-active': path === '/contact'
              })}>
                Contact Us
              </Link>
            </div>
          </div>
        </nav>
      </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/Header.js